import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Add auth token to admin requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lazuli_admin_token');
  if (token && config.url.includes('/admin')) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public
export const getServices = () => api.get('/services').then(r => r.data);
export const getService = (slug) => api.get(`/services/${slug}`).then(r => r.data);
export const getBlogPosts = (category) => api.get('/blog-posts', { params: category ? { category } : {} }).then(r => r.data);
export const getBlogPost = (slug) => api.get(`/blog-posts/${slug}`).then(r => r.data);
export const getResources = () => api.get('/resources').then(r => r.data);
export const getResource = (slug) => api.get(`/resources/${slug}`).then(r => r.data);
export const downloadResource = (slug, email) => api.post(`/resources/${slug}/download`, { email }).then(r => r.data);
export const getClients = () => api.get('/clients').then(r => r.data);
export const getPartners = () => api.get('/partners').then(r => r.data);
export const getFormations = () => api.get('/formations').then(r => r.data);
export const submitContact = (data) => api.post('/contact', data).then(r => r.data);

// Admin
export const adminLogin = (password) => api.post('/admin/login', { password }).then(r => r.data);
export const adminVerify = () => api.get('/admin/verify').then(r => r.data);
export const adminGetStats = () => api.get('/admin/stats').then(r => r.data);

export const adminGetPosts = () => api.get('/admin/blog-posts').then(r => r.data);
export const adminCreatePost = (data) => api.post('/admin/blog-posts', data).then(r => r.data);
export const adminUpdatePost = (id, data) => api.put(`/admin/blog-posts/${id}`, data).then(r => r.data);
export const adminDeletePost = (id) => api.delete(`/admin/blog-posts/${id}`).then(r => r.data);

export const adminGetResources = () => api.get('/admin/resources').then(r => r.data);
export const adminCreateResource = (data) => api.post('/admin/resources', data).then(r => r.data);
export const adminUpdateResource = (id, data) => api.put(`/admin/resources/${id}`, data).then(r => r.data);
export const adminDeleteResource = (id) => api.delete(`/admin/resources/${id}`).then(r => r.data);
export const adminUploadResourcePdf = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/admin/resources/${id}/upload-pdf`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};

export const adminGetClients = () => api.get('/admin/clients').then(r => r.data);
export const adminCreateClient = (data) => api.post('/admin/clients', data).then(r => r.data);
export const adminUpdateClient = (id, data) => api.put(`/admin/clients/${id}`, data).then(r => r.data);
export const adminDeleteClient = (id) => api.delete(`/admin/clients/${id}`).then(r => r.data);

export const adminGetPartners = () => api.get('/admin/partners').then(r => r.data);
export const adminCreatePartner = (data) => api.post('/admin/partners', data).then(r => r.data);
export const adminUpdatePartner = (id, data) => api.put(`/admin/partners/${id}`, data).then(r => r.data);
export const adminDeletePartner = (id) => api.delete(`/admin/partners/${id}`).then(r => r.data);

export const adminGetFormations = () => api.get('/admin/formations').then(r => r.data);
export const adminCreateFormation = (data) => api.post('/admin/formations', data).then(r => r.data);
export const adminUpdateFormation = (id, data) => api.put(`/admin/formations/${id}`, data).then(r => r.data);
export const adminDeleteFormation = (id) => api.delete(`/admin/formations/${id}`).then(r => r.data);

export const adminGetContacts = () => api.get('/admin/contacts').then(r => r.data);
export const adminMarkContactRead = (id) => api.put(`/admin/contacts/${id}/read`).then(r => r.data);
export const adminDeleteContact = (id) => api.delete(`/admin/contacts/${id}`).then(r => r.data);

export const adminGetDownloadStats = () => api.get('/admin/downloads/stats').then(r => r.data);
export const adminGetSubscribers = () => api.get('/admin/subscribers').then(r => r.data);
